const WRGGHeaderLogo = ({ className = "block h-9 w-auto" }) => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="16 18 590 252" role="img" aria-label="Winrates.gg logo" className={className}>
        <defs>
            <linearGradient id="headerRingGrad" x1="135" y1="55" x2="330" y2="235" gradientUnits="userSpaceOnUse">
                <stop offset="0%" stopColor="#45D7FF" />
                <stop offset="100%" stopColor="#2FA8FF" />
            </linearGradient>
            <linearGradient id="headerCursorGrad" x1="35" y1="80" x2="250" y2="205" gradientUnits="userSpaceOnUse">
                <stop offset="0%" stopColor="#86F5F2" />
                <stop offset="100%" stopColor="#35B6FF" />
            </linearGradient>

            <mask id="headerRingCut">
                <rect width="100%" height="100%" fill="white" />
                <path d="M72 90 L162 120 L162 170 L72 200 L72 156 L118 145 L72 134 Z" fill="black" />
                <path d="M97 122 L169 146 L97 170 L130 146 Z" fill="black" />
            </mask>

            <mask id="headerCursorHoleMask">
                <rect width="100%" height="100%" fill="white" />
                <path d="M97 122 L169 146 L97 170 L130 146 Z" fill="black" />
            </mask>
        </defs>

        <ellipse
            cx="230"
            cy="145"
            rx="78"
            ry="94"
            fill="none"
            stroke="url(#headerRingGrad)"
            strokeWidth="20"
            mask="url(#headerRingCut)"
        />

        <path
            d="M35 69 L261 146 L35 229 L76 149 Z"
            fill="url(#headerCursorGrad)"
            mask="url(#headerCursorHoleMask)"
            transform="translate(148 146) scale(0.94) translate(-148 -146)"
        />

        <text
            x="338"
            y="192"
            fill="#FFFFFF"
            fontFamily="'Rajdhani', 'Orbitron', 'Exo 2', 'Montserrat', sans-serif"
            fontSize="128"
            fontWeight="600"
            letterSpacing="2"
        >
            WIN
        </text>
    </svg>
)

export default WRGGHeaderLogo
